export default "<div class=\"continue-text\">{{ continueText }}</div>\n";